import triggerOneDOMEvent from './_triggeronedomevent.js';
import forEach from '../_helpers/foreach.js';
// triggers DOM event on bound nodes
export default function triggerDOMEvent(def, key, eventName, selector, triggerArgs) {
  var _def$props$key;
  var bindings = (_def$props$key = def.props[key]) == null ? void 0 : _def$props$key.bindings;
  if (!bindings) {
    return;
  }
  forEach(bindings, function (_ref) {
    var node = _ref.node;
    if (selector) {
      // a text or attribute node (bound by parseBindings) has no descendants
      if (!('querySelectorAll' in node)) return;
      // if selector is given trigger an event on all node descendants
      var descendants = node.querySelectorAll(selector);
      forEach(descendants, function (descendant) {
        triggerOneDOMEvent({
          node: descendant,
          eventName: eventName,
          triggerArgs: triggerArgs
        });
      });
    } else {
      // trigger an event for single node
      triggerOneDOMEvent({
        node: node,
        eventName: eventName,
        triggerArgs: triggerArgs
      });
    }
  });
}